module.exports = __webpack_public_path__ + "static/media/FFG.910af71d.webm";